var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.dataFrom ? _c("div", [_c("div", {
    staticClass: "codeBox"
  }, [_c("div", {
    staticClass: "left"
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.dataRule,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "name",
      label: _vm.$t("模版名称")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("模版名称"),
      disabled: !_vm.dataFrom.isEdit,
      maxLength: 50
    },
    model: {
      value: _vm.dataFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "name", $$v);
      },
      expression: "dataFrom.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "linkType",
      label: _vm.$t("链接类型")
    }
  }, [_c("a-radio-group", {
    attrs: {
      disabled: !_vm.dataFrom.isEdit
    },
    on: {
      change: _vm.linkTypeChange
    },
    model: {
      value: _vm.dataFrom.linkType,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "linkType", $$v);
      },
      expression: "dataFrom.linkType"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "NEW_LINK"
    }
  }, [_vm._v(_vm._s(_vm.$t("新链接")))]), _c("a-radio", {
    attrs: {
      value: "COMPLETE"
    }
  }, [_vm._v(_vm._s(_vm.$t("已开发完成")))])], 1)], 1), _vm.dataFrom.linkType == "COMPLETE" ? _c("a-form-model-item", {
    staticClass: "box",
    attrs: {
      prop: "insureLink",
      label: _vm.$t("投保链接")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("投保链接"),
      disabled: !_vm.dataFrom.isEdit
    },
    model: {
      value: _vm.dataFrom.insureLink,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "insureLink", $$v);
      },
      expression: "dataFrom.insureLink"
    }
  }), _c("a-button", {
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        _vm.isClick = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("前往验证")))])], 1) : _vm._e(), _vm.dataFrom.linkType == "NEW_LINK" ? _c("div", [_c("a-form-model-item", {
    attrs: {
      prop: "domain",
      label: _vm.$t("域名")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("域名"),
      disabled: !_vm.dataFrom.isEdit
    },
    model: {
      value: _vm.dataFrom.domain,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "domain", $$v);
      },
      expression: "dataFrom.domain"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "address",
      label: _vm.$t("前端地址")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("前端地址"),
      disabled: !_vm.dataFrom.isEdit
    },
    model: {
      value: _vm.dataFrom.address,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "address", $$v);
      },
      expression: "dataFrom.address"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: "appId"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + "appId",
      disabled: !_vm.dataFrom.isEdit
    },
    model: {
      value: _vm.dataFrom.appId,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "appId", $$v);
      },
      expression: "dataFrom.appId"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("页面模版"),
      prop: "templateControlsGroupId"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("页面模版"),
      disabled: !_vm.dataFrom.isEdit
    },
    model: {
      value: _vm.dataFrom.templateControlsGroupId,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "templateControlsGroupId", $$v);
      },
      expression: "dataFrom.templateControlsGroupId"
    }
  }, _vm._l(_vm.templateGroupList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1), _c("div", [_vm._v(_vm._s(_vm.$t("说明：选择模版后右侧预览效果图")))])], 1)], 1) : _vm._e(), _c("a-form-model-item", {
    attrs: {
      "wrapper-col": {
        span: 14,
        offset: 4
      }
    }
  }, [_vm.dataFrom.isEdit ? _c("a-button", {
    staticClass: "marginR15",
    on: {
      click: function ($event) {
        _vm.infoFun(), _vm.$emit("cancel", _vm.num - 1);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("取消")) + " ")]) : _vm._e(), _vm.dataFrom.isEdit ? _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("保存")) + " ")]) : _vm._e(), !_vm.dataFrom.isEdit ? _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onEdit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("编辑")) + " ")]) : _vm._e(), !_vm.dataFrom.isEdit ? _c("a-button", {
    attrs: {
      type: "danger"
    },
    on: {
      click: _vm.onDelete
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("删除")) + " ")]) : _vm._e()], 1)], 1)], 1)])]) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };